import { Memory, MemoryImpl } from '../domain/entities/Memory';
import { BlobServiceClient } from '@azure/storage-blob';

const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
const videoExtensions = ['.mp4', '.webm'];

// Azure Storage configuration
const STORAGE_ACCOUNT_NAME = "ukskristinasa";
const CONTAINER_NAME = "valentines2025";
// SAS token (if container is not public)
const STORAGE_SAS_TOKEN = process.env.REACT_APP_AZURE_STORAGE_SAS_TOKEN || "";

// Helper function to extract date from filename
function extractDateFromPath(path: string): Date {
    const match = path.match(/\d{4}-\d{2}-\d{2}/);
    return match ? new Date(match[0]) : new Date();
}

export async function loadMemories(): Promise<Memory[]> {
    const memories: Memory[] = [];
    let memoryIndex = 0;

    // Function to determine media type from file extension
    const getMediaType = (path: string): 'IMAGE' | 'VIDEO' | null => {
        const lowerPath = path.toLowerCase();
        if (imageExtensions.some(ext => lowerPath.endsWith(ext))) return 'IMAGE';
        if (videoExtensions.some(ext => lowerPath.endsWith(ext))) return 'VIDEO';
        return null;
    };

    try {
        // Set up Azure Storage client
        let blobServiceUrl = `https://${STORAGE_ACCOUNT_NAME}.blob.core.windows.net`;
        
        // Append SAS token if available
        if (STORAGE_SAS_TOKEN) {
            blobServiceUrl += `?${STORAGE_SAS_TOKEN}`;
        }
        
        const blobServiceClient = new BlobServiceClient(blobServiceUrl);
        const containerClient = blobServiceClient.getContainerClient(CONTAINER_NAME);
        
        // List all blobs
        const blobItems = [];
        for await (const blob of containerClient.listBlobsFlat()) {
            blobItems.push(blob);
        }
        
        console.log(`Found ${blobItems.length} files in Azure Storage container`);
        
        for (const blobItem of blobItems) {
            const blobName = blobItem.name;
            const mediaType = getMediaType(blobName);
            
            if (mediaType) {
                const id = `memory-${++memoryIndex}`;
                const blobClient = containerClient.getBlockBlobClient(blobName);
                
                memories.push(
                    new MemoryImpl(
                        id,
                        `Memory ${memoryIndex}`,
                        '',
                        extractDateFromPath(blobName),
                        'SHARED_EXPERIENCE',
                        blobClient.url,
                        mediaType
                    )
                );
            }
        }

        // Sort memories by date
        memories.sort((a, b) => a.date.getTime() - b.date.getTime());
        console.log('Loaded memories:', memories);
    } catch (error) {
        console.error('Error loading memories from Azure Blob Storage:', error);
    }

    return memories;
}